export function redirectFromIframe(link) {
  window.parent.postMessage(
    {
      redirectUrl: link,
    },
    "*"
  );
}

export function postMessage(message) {
  console.log("Posting message", JSON.stringify(message));
  window.parent.postMessage(message, "*");
}
